import { Pipe, PipeTransform } from '@angular/core';

interface IcountrytimeZoneResponse {
  id: string;
  isoCountryCode: string;
  name: string;
  timezoneList: ITimezoneObj[];
}

interface ITimezoneObj {
  name: string;
  timezone: string;
}

@Pipe({
  name: 'blockedCountries'
})
export class BlockedCountriesPipe implements PipeTransform {
  blockedCountryList:string[] = ['CU', 'IR', 'SD', 'SY'];
  transform(countries: Array<IcountrytimeZoneResponse>): Array<IcountrytimeZoneResponse> {
      let _countries: Array<IcountrytimeZoneResponse> = [];
      countries.forEach( country => {
        if (this.blockedCountryList.indexOf(country.isoCountryCode) === -1) {
          _countries.push(country);
        }
      });
      return _countries;
  }
}
